import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SEO } from '../components/seo/index.js';
import { ErrorScreen } from '../components/shared/ErrorScreen.js';

export function ServerErrorPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <SEO noindex title={t('common.serverError.title', { defaultValue: 'Server error' })} description="An unexpected server error occurred." />
      <ErrorScreen
        code="500"
        bubble={t('errors.serverError.bubble', { defaultValue: 'Whoa — something tripped on our side, not yours.' })}
        title={t('common.serverError.heading', { defaultValue: 'Something broke on our end' })}
        message={t('common.serverError.body', {
          defaultValue: 'Try again in a moment. If the problem continues, let us know and we’ll dig in.',
        })}
        actions={[
          {
            label: t('common.serverError.tryAgain', { defaultValue: 'Try again' }),
            onClick: () => window.location.reload(),
            variant: 'primary',
            icon: 'rotate-ccw',
          },
          {
            label: t('common.backHome', { defaultValue: 'Back home' }),
            onClick: () => navigate('/'),
            variant: 'secondary',
            icon: 'home',
          },
          {
            label: t('common.serverError.reportIssue', { defaultValue: 'Report issue' }),
            onClick: () => navigate('/support'),
            variant: 'ghost',
          },
        ]}
      />
    </>
  );
}
